function setupWebsiteNavbarMenu() {
    const navbar = document.querySelector(".website-navbar");
    const toggle = document.querySelector(".website-navbar__menu-toggle");
    const resourcesDropdown = document.querySelector(".website-navbar__dropdown");
    const resourcesToggle = document.querySelector(".website-navbar__dropdown-toggle");

    if (!navbar || !toggle) {
        return;
    }

    const toggleIcon = toggle.querySelector(".material-symbols-outlined");
    const navLinks = navbar.querySelectorAll(".website-navbar__menu .website-navbar__link");

    const closeResourcesDropdown = () => {
        if (!resourcesDropdown || !resourcesToggle) {
            return;
        }

        resourcesDropdown.classList.remove("is-open");
        resourcesToggle.setAttribute("aria-expanded", "false");
    };

    const openResourcesDropdown = () => {
        if (!resourcesDropdown || !resourcesToggle) {
            return;
        }

        resourcesDropdown.classList.add("is-open");
        resourcesToggle.setAttribute("aria-expanded", "true");
    };

    const closeMenu = () => {
        navbar.classList.remove("is-menu-open");
        document.body.classList.remove("website-nav-open");
        closeResourcesDropdown();
        if (toggleIcon) toggleIcon.textContent = "menu";
        toggle.setAttribute("aria-label", "Abrir menú");
        toggle.setAttribute("aria-expanded", "false");
    };

    const openMenu = () => {
        navbar.classList.add("is-menu-open");
        document.body.classList.add("website-nav-open");
        if (toggleIcon) toggleIcon.textContent = "close";
        toggle.setAttribute("aria-label", "Cerrar menú");
        toggle.setAttribute("aria-expanded", "true");
    };

    toggle.addEventListener("click", () => {
        const isOpen = navbar.classList.contains("is-menu-open");
        if (isOpen) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    navLinks.forEach((link) => {
        link.addEventListener("click", () => closeMenu());
    });

    if (resourcesToggle && resourcesDropdown) {
        resourcesToggle.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();

            const isOpen = resourcesDropdown.classList.contains("is-open");
            if (isOpen) {
                closeResourcesDropdown();
            } else {
                openResourcesDropdown();
            }
        });

        document.addEventListener("click", (event) => {
            if (!resourcesDropdown.contains(event.target)) {
                closeResourcesDropdown();
            }
        });
    }

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closeMenu();
        }
    });

    window.addEventListener("resize", () => {
        const isToggleHidden = window.getComputedStyle(toggle).display === "none";

        if (window.innerWidth > 1200 || isToggleHidden) {
            closeMenu();
            closeResourcesDropdown();
        }
    });
}

function setupWebsiteLangSwitcher() {
    const langSwitcher = document.getElementById("lang-switcher");
    if (!langSwitcher) {
        return;
    }

    langSwitcher.addEventListener("click", () => {
        const activeLang = langSwitcher.getAttribute("data-active-lang") === "EN" ? "EN" : "ES";
        const nextLang = activeLang === "EN" ? "ES" : "EN";
        const baseUrl = nextLang === "EN" ? langSwitcher.dataset.urlEn : langSwitcher.dataset.urlEs;
        if (!baseUrl) return;

        const next = window.location.pathname + window.location.search;
        window.location.href = `${baseUrl}?next=${encodeURIComponent(next)}`;
    });
}

function setupWebsiteNavbarScroll() {
    const navbar = document.querySelector(".website-navbar");
    if (!navbar || !document.body.classList.contains("website-home")) return;

    const THRESHOLD = 10;

    const update = () => {
        if (window.scrollY > THRESHOLD) {
            navbar.classList.add("is-scrolled");
        } else {
            navbar.classList.remove("is-scrolled");
        }
    };

    window.addEventListener("scroll", update, { passive: true });
    update();
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
        setupWebsiteNavbarMenu();
        setupWebsiteNavbarScroll();
        setupWebsiteLangSwitcher();
    });
} else {
    setupWebsiteNavbarMenu();
    setupWebsiteNavbarScroll();
    setupWebsiteLangSwitcher();
}
